// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const baseurl = 'https://superpesos.mefid.com.co';
// const baseFront = 'https://mefid.co';
// const baseImageUrl = 'https://mefid.com.co';

// const baseurl = 'http://192.168.1.66:8000';
// const baseurl = 'http://25.102.115.7:8000';
// const baseurl = 'https://mefid.com.co/';

const baseurldiagnostico = 'https://api.convenios.unidrogas.com/';

const baseRedeca = 'https://api.redeca.unidrogas.com';


//const baseurl = 'https://mefid.com.co';
// const baseFront = 'http://192.168.1.80:4200';
const baseFront = 'https://superpesos.mefid.co';
// const baseImageUrl = 'http://192.168.1.66:8000';
const baseImageUrl = 'https://superpesos.mefid.com.co';

const androidRedirect =
  'https://play.google.com/store/apps/details?id=com.binar10.mefid';
const iosRedirect = 'https://apps.apple.com/co/app/mefid/id1473990265';
export const environment = {
  production: false,
  baseImageUrl,

  //Landing registro
  api_generate_url: baseurl + '/medic/generate_url/',
  api_formulario: baseurl + '/medic/add_referral_session/',


  playStoreLink: androidRedirect,
  iTunesLink: iosRedirect,
  // Rutas del login
  ApiLink: baseFront,
  Api_login: baseurl + '/user/login/',
  Api_update_medic: baseurl + '/user/update_password_medic/',
  Api_forgot_password: baseurl + '/user/forgot_password/',
  Api_verify_code: baseurl + '/user/recover_password/',
  Api_change_password: baseurl + '/user/change_password/',

  // Login register
  Api_get_countries: baseurl + '/administrator/cities_list/',
  Api_register_medic: baseurl + '/medic/register_referred_medic/',

  // Rutas de comerciales
  API_RESET_CREDENTIALS_COMERCIAL_MEDIC:
    baseurl + '/comercial/resend_credentials_medic/',
  Api_comercial_register: baseurl + '/administrator/comercial_register/',


  // === RUTAS PARA ADMINISTRADORES DE ALIANZAS ===


  // Rutas ciudad
  Api_add_city: baseurl + '/administrator/add_city/',
  Api_delete_city: baseurl + '/administrator/delete_city/',

  // Rutas de medicos
  Api_medic_id: baseurl + '/comercial/medic_details/',
  Api_medic_register: baseurl + '/comercial/medic_register/',
  Api_get_especialties: baseurl + '/administrator/specialties_list/',
  Api_get_especialties2: baseurl + '/administrator/specialties_list2/',
  Api_get_states: baseurl + '/administrator/state_list/',
  Api_get_medic_statistics: baseurl + '/medic/medic_statistics/',
  Api_get_prize: baseurl + '/medic/get_rewards',
  api_get_rem: baseurl + '/medic/redeem_reward/',
  // Rutas nuevas de medico
  Api_get_brand: baseurl + '/medic/get_brand/',
  Api_get_zones: baseurl + '/medic/get_zone/',
  Api_get_citys: baseurl + '/medic/get_city/',
  Api_get_site: baseurl + '/medic/get_site/',

  // <--
  api_verified_cell: baseurl + '/medic/verify_phone/',
  api_verified_verify: baseurl + '/medic/send_verify_phone/',

  api_mypoints: baseurl + '/medic/view_redemptions/',
  api_statement_point: baseurl + '/medic/points_statement/',

  // Rutas de pacientes
  Api_get_medic_specialties: baseurl + '/medic/get_medic_specialties/',
  Api_create_patient: baseurl + '/medic/add_referral/',

  // Rutas seguimientos
  Api_tracing_medic_id: baseurl + '/medic_referrals/',
  Api_monitoring_graphics: baseurl + '/comercial/monitoring/',

  // Listas
  Api_get_medic: baseurl + '/comercial/medic_list/',
  Api_get_monitoring_comercial: baseurl + '/comercial/medic_monitoring/',
  Api_get_medic_referral: baseurl + '/comercial/medic_referrals/',
  Api_get_comercial_referral: baseurl + '/comercial/referrals/',
  Api_get_referral: baseurl + '/medic/view_my_referrals/',

  // info user menu
  Api_get_user: baseurl + '/user/get_user_name/',
  Api_logout: baseurl + '/user/logout/',
  Api_info_user: baseurl + '/user/user_info/',
  Api_update_password: baseurl + '/user/update_password/',
  api_surveys: baseurl + '/medic/view_active_surveys/',

  // debug
  Api_debug: baseurl + '/administrator/switch_debug/',

  Api_medic_profile_get: baseurl + '/medic/profile/',
  Api_medic_profile_update: baseurl + '/medic/profile/',
  Api_cities_list: baseurl + '/administrator/cities/',

  // Rutas de admin
  Api_get_all_commercial_active_list:
    baseurl + '/administrator/comercial_activity/',
  Api_get_all_commercial_list: baseurl + '/administrator/comercial_list/',
  Api_get_all_medic_list: baseurl + '/administrator/medic_list/',
  Api_get_all_message: baseurl + '/administrator/message_list/',
  Api_get_all_patient_list: baseurl + '/administrator/patient_list/',
  Api_get_all_user_list: baseurl + '/administrator/users_list/',
  Api_get_user_details: baseurl + '/administrator/users_details/',
  Api_post_user_details: baseurl + '/administrator/users_details/',
  Api_get_user_activate: baseurl + '/administrator/activate_user/',
  Api_medic_graphics: baseurl + '/administrator/medic_statistics/',
  Api_comercial_graphics: baseurl + '/administrator/comercial_statistics/',
  Api_get_channels: baseurl + '/administrator/channel_list/',
  Api_enviar_mensaje_masivo: baseurl + '/administrator/send_messages/',
  Api_message_type: baseurl + '/administrator/messagetype_list/',
  Api_get_admin_list: baseurl + '/administrator/admins_list/',
  Api_admin_register: baseurl + '/administrator/comercial_register/',
  Api_admin_resend_credentials: baseurl + '/administrator/resend_credentials/',
  Api_view_medic_redemptions:
    baseurl + '/administrator/view_medic_redemptions/',
  Api_get_logs: baseurl + '/administrator/get_logs/',
  Api_pool_cities: baseurl + '/administrator/cities_list3/',
  Api_admin_stats: baseurl + '/administrator/general_statistics/',
  Api_admin_get_achievement: baseurl + '/administrator/get_achievement/',
  Api_admin_edit_achievement: baseurl + '/administrator/edit_achievement/',
  Api_all_cities: baseurl + '/administrator/cities_list2/',
  Api_admin_medic_details: baseurl + '/administrator/medic_details/',
  API_UPDATE_COMERCIAL_DATA: baseurl + '/administrator/users_details/',

  Api_alliances_list: baseurl + '/alliance/api/alliances/',
  Api_create_alliance: baseurl + '/alliance/api/alliances/',
  Api_alliance_detail: baseurl + '/alliance/api/alliances/',

  Api_alliance_administrators_list: baseurl + '/alliance/api/administrators/',
  Api_alliance_administrators_detail: baseurl + '/alliance/api/administrators/',
  Api_alliance_administrators_detail_edit: baseurl + '/alliance/api/administrators/',

  Api_challenges_list: baseurl + '/badges/challenges/',
  Api_create_challenge: baseurl + '/badges/challenges/',
  Api_challenge_detail: baseurl + '/badges/challenges/',

  Api_badges_list: baseurl + '/badges/badges/',
  Api_create_badge: baseurl + '/badges/badges/',
  Api_badge_detail: baseurl + '/badges/badges/',

  Api_medals_list: baseurl + '/badges/medals/',
  Api_create_medal: baseurl + '/badges/medals/',
  Api_medal_detail: baseurl + '/badges/medals/',


  // Api_alliances_list: baseurl + '/alliances/api/alliances/',
  // Api_create_alliance: baseurl + '/alliances/api/alliances/',
  // Api_alliance_detail: baseurl + '/alliances/api/alliances/',

  Api_create_survey_new: baseurl + '/administrator/create_survey/',
  Api_surveys_list_new: baseurl + '/surveys_list/',
  Api_survey_details_new: baseurl + '/administrator/survey_details/',
  Api_survey_statistics_new: baseurl + '/administrator/survey_statistics/',
  Api_activate_survey_new: baseurl + '/administrator/activate_survey/',
  Api_delete_survey_new: baseurl + '/administrator/delete_survey/',
  Api_add_survey_question_new: baseurl + '/administrator/add_survey_question/',
  Api_edit_survey_question_new: baseurl + '/administrator/edit_survey_question/',
  Api_delete_survey_question_new: baseurl + '/administrator/delete_survey_question/',
  Api_add_survey_answer_new: baseurl + '/administrator/add_survey_answer/',
  Api_edit_survey_answer_new: baseurl + '/administrator/edit_survey_answer/',
  Api_delete_survey_answer_new: baseurl + '/administrator/delete_survey_answer/',
  Api_edit_survey_title_new: baseurl + '/administrator/edit_survey_title/',
  Api_edit_survey_description_new: baseurl + '/administrator/edit_description/',
  Api_export_survey_excel: baseurl + '/administrator/export_survey_excel/',
  Api_detailed_text_analysis: baseurl + '/administrator/detailed_text_analysis/',
  Api_get_survey_for_medic: baseurl + '/administrator/get_survey_for_medic/',
  Api_submit_survey_response: baseurl + '/administrator/submit_survey_response/',

  // === RUTAS PARA FILTROS EAN ===
  Api_filtros_ean_listar: baseurl + '/external/filtros-ean/',
  Api_filtros_ean_crear: baseurl + '/external/filtros-ean/crear/',
  Api_filtros_ean_detalle: baseurl + '/external/filtros-ean/',
  Api_filtros_ean_actualizar: baseurl + '/external/filtros-ean/',
  Api_filtros_ean_productos: baseurl + '/external/product_list/',


  Api_listar_medicos_alianzas: baseurl + '/alliance/api/medic-alliances/',
  Api_crear_medico_alianza: baseurl + '/alliance/api/medic-alliances/',
  Api_obtener_medico_alianza: baseurl + '/alliance/api/medic-alliances/', // Se concatena con el ID
  Api_actualizar_medico_alianza: baseurl + '/alliance/api/medic-alliances/', // Se concatena con el ID
  Api_eliminar_medico_alianza: baseurl + '/alliance/api/medic-alliances/', // Se concatena con el ID
  Api_medicos_por_alianza: baseurl + '/alliance/api/alliances/',
  Api_agregar_medico_alianza: baseurl + '/alliance/api/alliances/',

  // Rutas adicionales que podrías necesitar para los selects del formulario
  Api_lista_medicos_disponibles: baseurl + '/medic/medics_list/', // Para obtener lista de médicos
  Api_lista_alianzas_disponibles: baseurl + '/alliance/api/alliances/', // Para obtener lista de alianzas


  // Agregar estos endpoints al archivo environment.ts

  // === RUTAS PARA COMERCIALES EN ALIANZAS ===
  Api_listar_comerciales_alianzas: baseurl + '/alliance/api/commercial-alliances/',
  Api_crear_comercial_alianza: baseurl + '/alliance/api/commercial-alliances/',
  Api_obtener_comercial_alianza: baseurl + '/alliance/api/commercial-alliances/', // Se concatena con el ID
  Api_actualizar_comercial_alianza: baseurl + '/alliance/api/commercial-alliances/', // Se concatena con el ID
  Api_eliminar_comercial_alianza: baseurl + '/alliance/api/commercial-alliances/', // Se concatena con el ID
  Api_comerciales_por_alianza: baseurl + '/alliance/api/alliances/',
  Api_agregar_comercial_alianza: baseurl + '/alliance/api/alliances/',

  // Rutas adicionales para los selects del formulario
  Api_lista_comerciales_disponibles: baseurl + '/administrator/comercial_list/', // Para obtener lista de comerciales

  // === NUEVAS RUTAS PARA BÚSQUEDA Y ASOCIACIÓN DE COMERCIALES ===
  Api_buscar_comercial_por_dni: baseurl + '/alliance/search-commercial/',
  Api_asociar_comercial_alianza: baseurl + '/alliance/associate-commercial/',

  // === NUEVAS RUTAS PARA BÚSQUEDA Y ASOCIACIÓN DE MÉDICOS ===
  Api_buscar_medico_por_dni: baseurl + '/alliance/search-medic/',
  Api_asociar_medico_alianza: baseurl + '/alliance/associate-medic/',
  Api_desasociar_medico_alianza: baseurl + '/alliance/disassociate-medic/',



  Api_banners_list: baseurl + '/advertising/admin/banners/',  // Nueva ruta para listar banners
  Api_create_banner: baseurl + '/advertising/admin/banners/',  // Nueva ruta para crear banners
  Api_banner_detail: baseurl + '/advertising/admin/banners/',  // Nueva ruta para obtener/actualizar/eliminar banner específico

  Api_popups_list: baseurl + '/advertising/admin/popups/',
  Api_create_popup: baseurl + '/advertising/admin/popups/',
  Api_popup_detail: baseurl + '/advertising/admin/popups/', // Se usa como base, se agrega el ID después

  // Rutas legacy (mantener por compatibilidad)
  Api_list_banner: baseurl + '/administrator/banners_list/',  // Deprecado
  Api_change_banner: baseurl + '/administrator/select_banner/',  // Deprecado
  Api_list_bannerId: baseurl + '/administrator/banner_details/',  // Deprecado
  Api_delete_banner: baseurl + '/administrator/delete_banner/',  // Deprecado
  Api_list_bannerMedic: baseurl + '/medic/view_banner/',  // Deprecado


  // URLs para configuraciones de notificaciones
  Api_notification_configurations_list: baseurl + '/notification/configuraciones/',
  Api_create_notification_configuration: baseurl + '/notification/configuraciones/crear/',
  Api_notification_configuration_detail: baseurl + '/notification/configuraciones/',
  Api_notification_configuration_toggle: baseurl + '/notification/configuraciones/',
  Api_notification_configuration_delete: baseurl + '/notification/configuraciones/',


  Api_analytics_popups: baseurl + '/advertising/admin/analytics/popups/',
  Api_analytics_banners: baseurl + '/advertising/admin/analytics/banners/',
  Api_analytics_comparative: baseurl + '/advertising/admin/analytics/comparative/',
  Api_analytics_performance: baseurl + '/advertising/admin/analytics/performance/',
  Api_analytics_engagement: baseurl + '/advertising/admin/analytics/engagement/',
  Api_analytics_conversion: baseurl + '/advertising/admin/analytics/conversion/',
  Api_analytics_export: baseurl + '/advertising/admin/analytics/export/',
  Api_analytics_alerts: baseurl + '/advertising/admin/analytics/alerts/',
  Api_analytics_heatmap: baseurl + '/advertising/admin/analytics/heatmap/',
  Api_analytics_audience: baseurl + '/advertising/admin/analytics/audience/',
  Api_analytics_retention: baseurl + '/advertising/admin/analytics/retention/',


  // rutas notificaciones
  Api_activar_referral_check_7:
    baseurl + '/administrator/enable_refferal_check_7/',
  Api_activar_unused_code_30: baseurl + '/administrator/enable_unused_code_30/',
  Api_activar_reward_available_check:
    baseurl + '/administrator/enable_reward_available_check/',
  API_MARCAR_USUARIOS_INACTIVOs_STATUS:
    baseurl + '/administrator/enable_inactive_check/',
  Api_get_notification_status:
    baseurl + '/administrator/get_notification_status/',
  Api_send_notification: baseurl + '/notification/send/',
  // rutas encuestas
  Api_create_survey: baseurl + '/administrator/create_survey/',
  Api_create_question: baseurl + '/administrator/add_survey_question',
  Api_list_survey: baseurl + '/administrator/survey_details/',
  Api_list_surveys: baseurl + '/medic/view_active_surveys/',
  Api_view_survey: baseurl + '/medic/view_survey_details/',
  Api_send_survey: baseurl + '/medic/fill_survey/',
  Api_send_new_answer: baseurl + '/medic/submit_survey_response/',
  Api_admin_list_surveys: baseurl + '/administrator/surveys_list',
  Api_create_answer: baseurl + '/administrator/add_survey_answer/',
  Api_update_survey_answer: baseurl + '/administrator/edit_survey_answer/',
  Api_update_survey_question: baseurl + '/administrator/edit_survey_question/',
  Api_update_survey_title: baseurl + '/administrator/edit_survey_title/',
  Api_update_survey_description: baseurl + '/administrator/edit_description/',
  Api_delete_survey_answer: baseurl + '/administrator/delete_survey_answer/',
  Api_delete_survey: baseurl + '/administrator/delete_survey/',
  Api_delete_question: baseurl + '/administrator/delete_survey_question/',
  Api_toggle_activate_survey: baseurl + '/administrator/activate_survey/',
  API_RESET_CREDENTIALS_SMS_MEDIC: baseurl + '/comercial/resend-credentials-medic-sms/',
  Api_resend_coupon_sms: baseurl + '/medic/resend_coupon_sms/',
  Api_get_patient_history: baseurl + '/medic/patient/',
  Api_send_scheduled_notification: baseurl + '/notification/notificaciones-programadas/',

  // ERROR DEL SERVIDOR
  Api_log_error: baseurl + '/user/errors_log/',
  Api_check_account: baseurl + '/user/email_verification/',

  // RUTAS ASOCIADO - ASSOCIATE
  associate: {
    GET_TOKEN: baseurl + '/associate/get_token',
    GET_MEDICS: baseurl + '/associate/view_medics',
  },

  //RUTA REPORTES

  ListMedicsGeneral: baseurl + '/administrator/all_medic_list/',

  ListarMedicComercial: baseurl + '/comercial/all_medic_list/',

  ListarMedicAndPatiend: baseurl + '/comercial/patient_medic/',

  ListarMedicAndPatiendAdmin: baseurl + '/administrator/patient_medic/',

  ListarPointReport: baseurl + '/comercial/medic_point_report/',

  administradorPointReport: baseurl + '/administrator/medic_point_report/',

  ComercialRetail: baseurl + '/comercial/retails/',

  administradorRetail: baseurl + '/administrator/retails/',

  ComercialNotUsed: baseurl + '/comercial/retails/not_used/',

  administradorNotUsed: baseurl + '/administrator/retails/not_used/',

  ProductList: baseurl + '/comercial/retails/productlist/',

  adminProductList: baseurl + '/administrator/retails/productlist/',

  formulaPatient: baseurl + '/administrator/view_formula_patient',

  allPatient: baseurl + '/administrator/view_patient_all/',

  viewFormula: baseurl + '/administrator/view_formula_all/',

  formula: baseurl + '/medic/view_formula_medic/',

  productsmedics: baseurl + '/medic/product_list/',

  diagnosticos: baseurl + '/medic/diagnostic_list',

  detalleFormula: baseurl + '/medic/view_formula_info/',

  detalleFormulaAsistente: baseurl + '/assistant/view_formula_info/',

  crearFormula: baseurl + '/medic/formula_medics_create/',

  BuscarPaciente: baseurl + '/medic/patient_referral_search/',

  ListarMetas: baseurl + '/administrator/goals_list/',

  MetasDetail: baseurl + '/administrator/goals_detail/',

  editMeta: baseurl + '/administrator/goal_update',

  registroMetas: baseurl + '/administrator/goals_register/',

  medicoLogros: baseurl + '/medic/medics_goals_list/',

  MedicAchivment: baseurl + '/medic/medics_goals_achieved/',

  CrearMeta: baseurl + '/administrator/goals_create/',

  listaAsistentes: baseurl + '/medic/assistant_list/',

  ComercialLogros: baseurl + '/comercial/medics_goals_list/',

  registroAsistentes: baseurl + '/administrator/assistant_reg_list',

  asistentes: baseurl + '/administrator/assistant_list',

  referirAsistente: baseurl + '/administrator/assistant_referral_list/',

  ListadoMedicoReferido: baseurl + '/medic/assistant_reg_list/',

  referrelMedic: baseurl + '/medic/assistant_referral_list/',

  crearAsistente: baseurl + '/medic/create_assistant/',

  rolListaAsistente: baseurl + '/assistant/assistant_reg_list/',

  addReferral: baseurl + '/assistant/add_referral/',

  ReferralList: baseurl + '/assistant/assistant_referral_list/',

  getMedicEspecialitiesAssistant: baseurl + '/assistant/get_medic_specialties/',

  getMedicPhoto: baseurl + '/medic/get_photo/',

  CreatePhoto: baseurl + '/medic/upload_photo/',

  xslAssistanList: baseurl + '/administrator/assistant_list/',

  xslRegList: baseurl + '/administrator/assistant_reg_list/',

  xslReferaList: baseurl + '/administrator/assistant_referral_list/',

  medicRedemption: baseurl + '/administrator/medic_redemptions_client/',

  formulaMedicReport: baseurl + '/administrator/formula_medics_report/',

  comercialMedicReport: baseurl + '/comercial/formula_medics_report/',

  comercialRedemption: baseurl + '/comercial/medic_redemptions_client/',

  efficiency: baseurl + '/administrator/report_efficiency/',

  xslRedepmtionAdminList: baseurl + '/administrator/medic_redemptions_client/',

  xslRetailAdmin: baseurl + '/administrator/retails/',

  xslComercialRedeption: baseurl + '/comercial/medic_redemptions_client/xls/',

  xslComercialRetail: baseurl + '/comercial/retails/xls/',

  RetailNotUsedAmidmin: baseurl + '/administrator/retails/not_used/',

  RetailNotUsedComercial: baseurl + '/comercial/retails/not_used/xls/',

  xslProductAdmin: baseurl + '/administrator/retails/productlist/',

  xslproductComercial: baseurl + '/comercial/retails/productlist/xls/',

  changeStatusAssistant: baseurl + '/medic/assistant_update/',

  campaingMefid: baseurl + '/administrator/goals_simple_list/',

  editComercialByAdmin: baseurl + '/administrator/comercial-medic-relation/',

  ListComercialAdmin: baseurl + '/administrator/comercial-list/',

  saberComercial: baseurl + '/administrator/comercial-by-medic-id/',

  formulaAssistant: baseurl + '/assistant/view_formula_medic/',

  ProductAssistant: baseurl + '/assistant/product_list/',

  PatientListAssistant: baseurl + '/assistant/patient_list/',

  CreateFormulaAsistente: baseurl + '/assistant/formula_medics_create/',

  getPrizeAssistant: baseurl + '/assistant/get_rewards/',

  getBrandAssistant: baseurl + '/assistant/get_brand/',

  getZoneAssistant: baseurl + '/assistant/get_zone/',

  getCityAssistant: baseurl + '/assistant/get_city/',

  getSiteAssistant: baseurl + '/assistant/get_site/',

  getPoints: baseurl + '/assistant/points_statement/',

  redemAssistant: baseurl + '/assistant/redeem_reward/',

  UpdatePointMedic: baseurl + '/administrator/update_medic_point/',

  API_GET_LABS: baseurl + '/catalogue/laboratories/',

  API_POST_LABS_MEDICS: baseurl + '/comercial/medics/',

  MEDIC: baseurl + '/medic/product_list/',

  PRODUCTS_MEDIC: baseurl + '/medic/product_list/',

  MEDIC_STATISTICS: baseurl + '/medic/medics',

  nearbyBranches: baseRedeca + '/external/sucursal_nearby',

  Api_getDetailPatient: baseurl + '/medic/patient_detail',

  Api_getMedic_Assistant: baseurl + '/assistant/medics_list',

  Api_getUsuarioSerch: baseurl + '/administrator/users_list_filter',

  comparar_prescripcion_unidrogas: baseurl + '/external/comparar-prescripcion-unidrogas/',

  comparar_prescripcion_compra: baseurl + '/external/comparar-prescripcion-compra/',

  // === RUTAS DE AUDITORÍA ===
  Api_audit_bonos: baseurl + '/audit/bonos/',
  Api_audit_bonos_stats: baseurl + '/audit/bonos/stats/',
  Api_audit_bonos_export: baseurl + '/audit/bonos/export/',
  Api_audit_login: baseurl + '/audit/login/',
  Api_audit_login_stats: baseurl + '/audit/login/stats/',
  Api_audit_login_export: baseurl + '/audit/login/export/',
  Api_audit_sp_contact: baseurl + '/audit/sp-contact/',
  Api_audit_sp_contact_stats: baseurl + '/audit/sp-contact/stats/',
  Api_audit_sp_contact_export: baseurl + '/audit/sp-contact/export/',

  // === RUTAS BONOS QR ===
  Api_bonusqr_public_qr: baseurl + '/bonusqr/public/qr/',
  Api_bonusqr_public_dynamic_qr: baseurl + '/bonusqr/public/dynamic-qr/',
  Api_bonusqr_generate_dynamic: baseurl + '/bonusqr/dynamic-qr/generate/',
  Api_bonusqr_admin: baseurl + '/bonusqr/admin/bonus-qr/',

};
